import { format, subDays } from 'date-fns';
import type { DashboardPresetFilters } from '@/entities/dashboards';

/**
 * Период дашборда по умолчанию — последние 30 дней. Без дефолтного периода
 * первое открытие грузит всю историю оценок, и агрегация на бэке занимает
 * секунды; ограничение периодом делает первый отклик быстрым.
 */
const DEFAULT_PERIOD_DAYS = 30;

/** Нижняя граница периода по умолчанию (YYYY-MM-DD). */
export const getDefaultDateFrom = (): string => format(subDays(new Date(), DEFAULT_PERIOD_DAYS), 'yyyy-MM-dd');

/** Верхняя граница периода по умолчанию (YYYY-MM-DD). */
export const getDefaultDateTo = (): string => format(new Date(), 'yyyy-MM-dd');

/**
 * Фильтры панели по умолчанию — те же, что возвращает «Сбросить фильтры»: период по умолчанию, без
 * атрибутных фильтров. Их показывает и пользовательский дашборд без своих фильтров; сброс
 * стандартного дашборда вдобавок возвращает всех консультантов.
 */
export const getDefaultPanelFilters = (): DashboardPresetFilters => ({
  dateFrom: getDefaultDateFrom(),
  dateTo: getDefaultDateTo(),
  attributeFilters: [],
});
